module.exports = __webpack_public_path__ + "static/rissalaPolo-f8cfbd5423d69b62cd68ddf5d2fc6fde.png";